export class User {
  constructor(obj) {
    this.userId = obj.userId;
    this.email = obj.email;
    this.fullName = obj.fullName;
    this.phoneNumber = obj.phoneNumber;
    this.createdAt = obj.createdAt;
  }
  static from(obj) {
    if (!obj) return null;
    return new User({
      userId: obj.user_id,
      email: obj.email,
      fullName: obj.full_name,
      phoneNumber: obj.phone_number,
      createdAt: obj.created_at_unix * 1000,
    });
  }
  static fromAll(data) {
    if (!data) return null;
    return data.map(User.from);
  }
}
